module.exports = __webpack_public_path__ + "img/ticket.e03c94d0.svg";